export enum RecipientRole {
  None = 'none',
  Signer = 'signer',
  CC = 'cc',
  Approver = 'approver',
  ExternalApprover = 'externalApprover',
}
